import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectItem } from './Select';
import { SelectMultiple } from './SelectMultiple';
import { QcsMenuItem } from '../basic/QcsMenuItem';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ConstructionIcon from '@mui/icons-material/Construction';
import { UserRole } from '@api/models/enums/UserRole';

const ROLES = [UserRole.ExternalManager, UserRole.ExternalWorker];

const ROLE_ICONS: Record<string, FC> = {
  [UserRole.ExternalManager]: EngineeringIcon,
  [UserRole.ExternalWorker]: ConstructionIcon,
};

interface Props {
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  multiple?: boolean;
  onRoleChange?: (role: UserRole) => void;
}

export const SupplierEmployeeRoleSelect: FC<Props> = ({
  name,
  label,
  disabled,
  required,
  multiple,
  onRoleChange,
}) => {
  const { t } = useTranslation();

  const handleChange = onRoleChange
    ? (e: any) => onRoleChange(e.target.value)
    : undefined;

  if (multiple) {
    return (
      <SelectMultiple
        name={name}
        label={label}
        disabled={disabled}
        required={required}
        options={ROLES}
        getOptionId={(role: string) => role}
        getOptionNameFromId={(role: string) => t(`user.role.${role}`)}
        onChange={handleChange}
      />
    );
  }

  return (
    <Select
      name={name}
      label={label}
      disabled={disabled}
      required={required}
      onChange={handleChange}
    >
      {ROLES.map((role) => {
        const Icon = ROLE_ICONS[role];
        return (
          <QcsMenuItem key={role} value={role}>
            <SelectItem>
              <Icon />
              <div>{t(`user.role.${role}`)}</div>
            </SelectItem>
          </QcsMenuItem>
        );
      })}
    </Select>
  );
};
